<template>
  <!-- Sección Parallax Inicial -->
  <div class="titulo relative py-16 px-6 text-center min-h-screen bg-cover bg-center md:bg-center pt-32 pb-32"
    :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerAzul.jpg')})` }">
    <div class="flex flex-col items-center justify-center text-center px-4">
      <img src="@/assets/img/loi-master/logo.jpg" alt="publicidad"
        class="w-70 h-43 mx-auto animate__animated animate__zoomInUp">
      <h1
        class="neon-black font-serif text-5xl text-yellow-400 font-extrabold animate__animated animate__zoomInLeft animate__slow">
        ¡El Futuro del Gaming está Aquí!
      </h1>
      <p class="neon-black text-white mt-10 text-lg animate__animated animate__zoomInRight animate__slower">
        No solo juegues, <b>¡posee, conquista y gana!</b> Sumérgete en una experiencia que difumina los límites entre la
        realidad y el mundo digital en <span class="text-yellow-500ch">Legends Of Interactions</span>.

      </p>
    </div>
  </div>

  <!-- Video de YouTube -->
  <div class="mt-14 mx-auto max-w-4xl px-6 lg:px-8">
    <div class="aspect-w-16 aspect-h-9">
      <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
        src="https://www.youtube.com/embed/3YsmO-sBU40?si=rtDminmFAq02umHG" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>

  <!-- Sección: Beneficios y Oportunidades -->
  <div class="mt-8 py-8">
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
      <section class="border border-black rounded-lg p-6 px-8 flex flex-col items-center mb-14 w-full">
        <!-- Imagen -->
        <img src="@/assets/img/loi-master/logo.jpg" alt="Insignia Gestor" class="w-45 h-26">

        <!-- Texto -->
        <div class="text-center mb-6">
          <h2 class="font-serif text-2xl font-bold text-gray-700 mb-2"></h2>
          <p class="text-gray-700">
            Legends of Interactions es una aventura de ciencia ficción que mezcla el mundo real con el digital,
            creando una experiencia única donde puedes explorar, comerciar y conquistar territorios.
          </p>
          <p class="text-2xl text-yellow-500 font-bold mt-6">
            Ecosistema de juego:
            cuatro mundos, una batalla
          </p>
        </div>

        <!-- Card 1 -->
        <div
          class="bg-black p-6 mb-2 rounded-lg shadow-lg w-full max-w-screen-lg text-center text-white bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
          :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoHexa.jpg')})` }">
          <h3 class="text-xl font-bold text-yellow-500">
            1. <span class="text-white">Mundo digital — la arena de los algoritmos</span>
          </h3>
          <p class="text-white">
            Bienvenido al abismo digital. Aquí mandan el código, el blockchain y el metaverso. No es solo un juego: es
            un sistema donde o te adaptas o quedas fuera. Las DAO deciden quién tiene el poder, la moneda del juego
            impone las reglas y las mecánicas determinan al realmente digno.
          </p>
        </div>

        <!-- Card 2 -->
        <div
          class="bg-black p-6 mb-2 rounded-lg shadow-lg w-full max-w-screen-lg text-center text-white bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
          :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoHexa.jpg')})` }">
          <h3 class="text-xl font-bold text-yellow-500">
            2. <span class="text-white">Mundo social — el campo de las manipulaciones</span>
          </h3>
          <p class="text-white">
            ¿Quién dijo que todo lo decide el equilibrio? El mundo lo dominan las alianzas, las intrigas, las guerras
            por territorios y las estrategias más astutas. Es un mercado donde no gana quien hace más clics, sino quien
            sabe manejar a las personas.
          </p>
        </div>


        <!-- Card 3 -->
        <div
          class="bg-black p-6 mb-2 rounded-lg shadow-lg w-full max-w-screen-lg text-center text-white bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
          :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoHexa.jpg')})` }">
          <h3 class="text-xl font-bold text-yellow-500">
            3. <span class="text-white"> Mundo físico — el mapa del juego en la realidad</span>
          </h3>
          <p class="text-white">
            Ya no existen fronteras entre lo virtual y lo real. Ciudades, países, calles… ahora todo forma parte del
            juego. El GPS y la realidad aumentada han convertido el mundo en un terreno de juego donde cualquiera puede
            dejar su marca.
          </p>
        </div>

        <!-- Card 4 -->
        <div
          class="bg-black p-6 mb-2 rounded-lg shadow-lg w-full max-w-screen-lg text-center text-white bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
          :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoHexa.jpg')})` }">
          <h3 class="text-xl font-bold text-yellow-500">
            4. <span class="text-white">Mundo económico — la caza del valor</span>
          </h3>
          <p class="text-white">
            El dinero también es un arma. En este mundo mandan la liquidez, la economía dentro del juego y la
            posibilidad de convertirlo todo en dinero real. Aquí no solo se juega: aquí se construye capital.
          </p>
        </div>


        <p class="text-gray-800 mt-4">
          Prepárate para esta nueva era de los videojuegos y sé de los primeros en experimentar Legends of Interactions.
          <b>¡El futuro del juego empieza ahora! 🚀</b>
        </p>
        <button @click.stop="mostrarInformacion()"
          class="mt-8 mb-6 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-white transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
          💬&nbsp;Comunicate con un asesor ahora
        </button>
      </section>
    </div>
  </div>

  <!-- Sección de Cacería -->
  <section
    class="bg-[#03396c] rounded-2xl p-8 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8 text-white">

    <!-- Texto principal -->
    <div class="flex-1 text-center md:text-left">
      <h2 class="text-3xl md:text-4xl font-bold">
        <span class="text-yellow-400">¿ESTÁS LISTO</span> PARA LA VERDADERA CACERÍA?
      </h2>

      <p class="mt-6 text-gray-200 leading-relaxed text-justify">
        En este juego no hay lugar para el azar. Aquí todo depende de tu estrategia, tu ritmo y tu habilidad para
        generar ganancias. No es solo correr por el mapa — es una guerra por artefactos valiosos, recompensas exclusivas
        y los activos de la economía real donde cada objeto recolectado puede convertirse en dinero.
      </p>

      <p class="mt-4 text-gray-200 leading-relaxed text-justify">
        Olvídate de los juegos donde gana quien más dinero invierte a través de donaciones. Aquí triunfa quien se mueve
        más rápido, piensa con más astucia y ve oportunidades donde otros solo ven píxeles.<br>
        Eres un cazador de valores digitales, y eso significa que el mundo real ahora es tu campo de juego. ¡Adelante! —
        a conquistar territorios, recoger trofeos y ganar dinero.
      </p>
    </div>

    <!-- Imagen -->
    <div class="flex-1">
      <img src="@/assets/img/loi-master/dosMundos.jpg" alt="Cacería" class="w-full rounded-lg shadow-lg">
    </div>

  </section>



  <!-- elijan su experiencia -->
  <div class=" flex flex-col items-center text-center justify-center min-h-screen text-white px-6 bg-cover bg-center">
    <img src="@/assets/img/loi-master/logo.jpg" alt="Icono loi" class="h-28 mx-auto">
    <h2 class="neon-text text-3xl font-bold text-yellow-400 mb-6 relative">
      ELIJAN SU ROL DE EXPERIENCIA
    </h2>
    <div class="flex flex-col md:flex-row gap-6 w-full max-w-4xl">
      <!-- Creadores de mercado -->
      <div
        class="flex-1 bg-[#03396c] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MARKET MAKERS</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Negocio basado en un juego</h4>
        <p class="text-gray-300">
          Creen orbes y objetos, pónganlos a la venta en el Marketplace, gestionen el negocio en la
          franquicia del juego y obtengan
          <span class="font-bold">remuneraciones.</span>
        </p>
        <p class="text-green-400 font-bold mt-4 mb-4">✅ ¡Abierto ahora! Participa hoy.</p>
        <a :href="`https://api.whatsapp.com/send?phone=521${participante.telefono}&text=%C2%A1Hola!%20Me%20interesa%20ser%20un%20Market%20Maker%20en%20Legends%20of%20Interactions%F0%9F%8E%AE%20y%20crear%20objetos%20para%20el%20Marketplace.%20%C2%BFC%C3%B3mo%20puedo%20comenzar%3F%F0%9F%92%A5`"
          target="_blank" @click="$emit('set-click')"
          class="mt-4 mb-6 bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-full text-sm shadow-md hover:shadow-lg hover:bg-yellow-500 transition-all">
          Quiero <span class="text-blue-800">Unirme</span>
        </a>
      </div>

      <!-- Masters Card -->
      <div
        class="flex-1 bg-[#03396c] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MASTERS OF GAME</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Plataforma del Juego como negocio</h4>
        <p class="text-gray-300">
          Diseñen y moldea el espacio del juego, comercia con tierras, recursos y otros objetos del juego, emprende en
          el negocio de publicidad dentro del mundo del juego y genera ingresos através de las interacciones en tu
          tierra virtual

        </p>
        <p class="text-green-400 font-bold mt-4 mb-4">✅ ¡Abierto ahora! Participa hoy.</p>
        <!-- Botón -->
        <a :href="`https://api.whatsapp.com/send?phone=521${participante.telefono}&text=%C2%A1Hola!%20Me%20interesa%20ser%20Master%20Of%20Game%20en%20Legends%20of%20Interactions%20y%20me%20interesa%20la%20oportunidad%20de%20invertir%20en%20parcelas%20digitales%F0%9F%93%88%20y%20generar%20ingresos%20en%20el%20juego.%20%C2%BFPodr%C3%ADas%20darme%20m%C3%A1s%20detalles%20sobre%20c%C3%B3mo%20funciona%3F%E2%9C%A8%F0%9F%8E%AE`"
          target="_blank" @click="$emit('set-click')"
          class="mt-4 mb-6 bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-full text-sm shadow-md hover:shadow-lg hover:bg-yellow-500 transition-all">
          Quiero <span class="text-blue-800">Unirme</span>
        </a>
      </div>

      <!-- Player Card -->
      <div class="flex-1 bg-[#03396c] p-6 mb-2 rounded-lg shadow-lg border border-gray-600 opacity-90">
        <h3 class="text-2xl font-bold">PLAYER</h3>
        <h4 class="text-yellow-400 font-bold mb-4">El juego como fuente de aventuras</h4>
        <p class="text-gray-300">
          Disfruta del proceso del juego, explora un mundo de oportunidades únicas, recibe experiencia de juego
          totalmente diferente y colecciona raros objetos digitales.
        </p>
        <p class="text-red-400 font-bold mt-4 mb-4">🚧 Próximamente: Apertura en otoño 2025.</p>
        <a
          class="mt-4 mb-6 bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-full text-sm shadow-md hover:shadow-lg hover:bg-yellow-500 transition-all">
          Quiero <span class="text-blue-800">Unirme</span>
        </a>
      </div>

    </div>
  </div>

  <!--Que a cambiado con este modelo-->
  <section
    class="bg-[#03396c] rounded-2xl p-8 max-w-6xl mx-auto mt-12 flex flex-col md:flex-row items-center gap-8 text-white">

    <!-- Texto principal -->
    <div class="flex-1 text-center md:text-left">
      <h2 class="text-3xl md:text-4xl font-bold">¿
        <span class="text-yellow-400">QUÉ HA CAMBIADO</span> CON LA LLEGADA DE ESTE MODELO
      </h2>

      <p class="mt-6 text-gray-200 leading-relaxed text-justify">
        ➡️ Los activos digitales se convirtieron en dinero — ahora puedes jugar y ganar al mismo tiempo.
      </p>

      <p class="mt-4 text-gray-200 leading-relaxed text-justify">
        ➡️ El mundo físico pasó a ser parte de la batalla — ahora las ciudades no son solo ubicaciones, son arenas de
        combate.
      </p>

      <p class="mt-4 text-gray-200 leading-relaxed text-justify">
        ➡️ La economía ahora va más allá del juego — ahora está conectada con el mundo y el mercado reales.
      </p>
    </div>

    <!-- Imagen -->
    <div class="flex">
      <img src="@/assets/img/loi-master/cuatroMundos.jpg" alt="Cacería" class="w-70 rounded-lg">
    </div>

  </section>

  <!-- Video de YouTube -->
  <div class="mt-14 mx-auto max-w-4xl px-6 lg:px-8">
    <div class="aspect-w-16 aspect-h-9">
      <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
        src="https://www.youtube.com/embed/WvxL5i44DYI?si=t495ihbG1dQGe_hx" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>



  <section
    class="mt-6 mb-6 relative w-full h-screen flex flex-col justify-center items-center text-center text-white overflow-hidden">

    <!-- Video de fondo -->
    <video autoplay muted loop playsinline class="absolute top-0 left-0 w-full h-full object-cover">
      <source src="@/assets/videos/videoFondo2.mp4" type="video/mp4">
      Tu navegador no soporta videos en HTML5.
    </video>

    <!-- Capa oscura para mejorar la visibilidad del texto -->
    <div class="absolute top-0 left-0 w-full h-full bg-black opacity-10"></div>

    <!-- Contenido encima del video -->
    <div class="relative z-10 px-2">
      <!-- Sección de Preguntas Frecuentes -->
      <div class="mb-6 px-4 text-center text-gray-800">
        <h3 class="neon-text text-5xl font-bold text-yellow-500"> Preguntas Frecuentes</h3>
        <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
          <summary class="font-semibold text-lg cursor-pointer">¿Necesito experiencia previa en videojuegos
            para
            participar? </summary>
          <p class="mt-2">
            No es obligatorio, pero tener conocimientos sobre mecánicas de juego y experiencia en liderazgo
            ayudará
            a desempeñar mejor tu rol.
          </p>
        </details>
        <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
          <summary class="font-semibold text-lg cursor-pointer"> ¿Puedo empezar antes del lanzamiento?
          </summary>
          <p class="mt-2">
            Sí, puedes prepararte como Creador de Mercado o Maestro del Juego y aprender sobre el sistema
            económico
            del juego y diseñar
            estrategias para aprovecharlas en el lanzamiento.
          </p>
        </details>

        <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
          <summary class="font-semibold text-lg cursor-pointer"> ¿Cuándo se lanza Legends of Interactions?
          </summary>
          <p class="mt-2">
            El videojuego se lanzará en otoño del presente año, pero para los que sean Maestros del Juego podrán acceder
            a una versión Beta en Abril del 2025
          </p>
        </details>
      </div>
    </div>
  </section>

  <!-- Llamada a la acción -->
  <div class="bg-linear-to-r from-orange-500 to-yellow-500 py-16 relative z-20 bg-cover bg-center"
    :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerAzul.jpg')})` }">
    <!-- CTA -->
    <section class="max-w-3xl mx-auto text-center py-12 px-6">
      <h2 class="neon-text font-serif text-4xl font-bold text-yellow-500"> El futuro del gaming está aquí. ¿Serás parte
        o te quedarás fuera?</h2>
      <p class="neon-black mt-4 text-lg text-white">No esperes a que el mundo del gaming cambie sin ti. En Legends of
        Interactions , puedes ser más que un jugador: puedes ser un dueño,
        un estratega y un generador de ingresos.</p>
      <button @click.stop="mostrarInformacion()"
        class="mt-18 mb-12 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-white transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
        💬&nbsp;Únete hoy y sé parte de la revolución
      </button>

      <p class="text-3xl font-serif mt-4 text-blue-900 font-bold  animated-gradient"> El momento de actuar es ahora</p>
    </section>
  </div>

  <div ref="modalContacto" class="hidden">
    <div style="color: #1e293b; font-family: 'Segoe UI', sans-serif; animation: fadeInZoom 0.5s ease;">
      <div style="margin-bottom: 1rem; text-align: center;">
        <h2 style="font-size: 1.8rem; font-weight: 700;">{{ participante.nombre || 'Sin nombre' }}</h2>
        <p style="color: #64748b; font-size: 0.95rem;">Información de contacto y enlaces</p>
      </div>
      <div style="padding: 1rem; text-align: left; background-color: #f1f5f9; border-radius: 10px;">
        <p style="margin-bottom: 10px;" v-if="participante.telefono">
          <strong>📲 WhatsApp: </strong>
          <a :href="`https://api.whatsapp.com/send?phone=521${participante.telefono}&text=¡Hola!%20Estoy%20interesado%20en%20conocer%20más%20sobre%20Legends%20of%20Interactions.%20¿Me%20puedes%20dar%20más%20información?`"
             target="_blank" class="text-blue-700">
            <i class="fa-brands fa-whatsapp mr-1"></i>{{ participante.telefono }}
          </a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.dato_identificacion">
          <strong>🪪 Datos de identificación: </strong>{{ participante.dato_identificacion }}
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.web_url">
          <strong>🌐 Sitio Web: </strong>
          <a :href="participante.web_url" target="_blank" class="text-blue-700">{{ participante.web_url }}</a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.registro_url">
          <strong>📝 Enlace de registro LOI: </strong>
          <a :href="participante.registro_url" target="_blank" class="text-blue-700">
            {{ participante.registro_url }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'loi-master2',
  props: {
    participante: {
      type: Object,
      default() {
        return {
          nombre: 'Virtual Shoppin Club',
          telefono: "4271615141",
          dato_identificacion: "",
          web_url: "https://virtualshoppingclub.com",
          registro_url: "https://virtualshoppingclub.com/registro",
        }
      }
    },
    sinParticipantes: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mostrarInformacion() {
      this.$emit('set-click')

      // Mostrar el modal con SweetAlert2
      this.$swal({
        title: 'Tu Asesor',
        html: this.$refs.modalContacto.innerHTML,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#D20103',
        background: '#FFFFFF',
        showClass: {
          popup: 'swal2-show-animate'
        },
        customClass: {
          popup: 'rounded-xl'
        },
        didOpen: () => {
          const style = document.createElement('style')
          style.innerHTML = `@keyframes fadeInZoom {
            0% { opacity: 0; transform: scale(0.9); }
            100% { opacity: 1; transform: scale(1); }
          }`
          document.head.appendChild(style)
        }
      })
    }
  }
}
</script>

<style scoped>
.neon-text {
  text-shadow: 0 0 10px #ffffff, 0 0 10px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
  text-shadow: 0 0 10px #000000, 0 0 20px #000000, 0 0 30px #000000;
}

@keyframes gradientChange {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.gradient-bg {
  background: linear-gradient(45deg, #3a065a, #1443ef, #3a065a, #1443ef);
  background-size: 400% 400%;
  animation: gradientChange 4s ease infinite;
}


.animated-gradient {
  animation: pulse 2s infinite;
  font-size: 2rem;
  /* Ajusta el tamaño */
  font-weight: 800;
  /* Fuente extrabold */
  text-align: center;
  /* Centrar texto */
  background: linear-gradient(90deg, #fffb25, #fffb25);
  /* Gradiente de 3 colores */
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  /* El gradiente aparecerá en lugar del color sólido */
  animation: gradient-animation 3s infinite;
  /* Añade la animación */
}

@keyframes gradient-animation {

  0%,
  100% {
    background-position: 0% 50%;
    transform: scale(0.8);
  }

  50% {
    background-position: 100% 50%;
    transform: scale(0.9);
  }
}
</style>